import { Nav, NavItem, Button, Collapse } from "reactstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import "./StaffSidebar.css";

const navigation = [
  {
    title: "Dashboard",
    href: "/bmo-user-admin-dashboard",
    icon: "bi bi-speedometer2",
  },
  {
    title: "User Management",
    icon: "bi bi-people",
    hasDropdown: true,
    children: [
      {
        title: "Manage Students",
        href: "/bmo-user-admin-dashboard/ManageStudents",
        icon: "bi bi-person-check",
      },
      {
        title: "BMO Officers",
        href: "/bmo-user-admin-dashboard/ManageBMOOfficers",
        icon: "bi bi-person-workspace",
      },
      {
        title: "User Permissions",
        href: "/bmo-user-admin-dashboard/UserPermissions",
        icon: "bi bi-shield-check",
      }
    ]
  },
  {
    title: "Bursary Management",
    href: "/bmo-user-admin-dashboard/CreateBursary",
    icon: "bi bi-award",
  },
  {
    title: "BMO Components",
    href: "/bmo-user-admin-dashboard/BursaryComponents",
    icon: "bi bi-puzzle",
  },
  {
    title: "Reports",
    icon: "bi bi-graph-up",
    hasDropdown: true,
    children: [
      {
        title: "Student Reports",
        href: "/bmo-user-admin-dashboard/StudentReports",
        icon: "bi bi-file-earmark-person",
      },
      {
        title: "Financial Reports",
        href: "/bmo-user-admin-dashboard/FinancialReports",
        icon: "bi bi-file-earmark-bar-graph",
      },
      {
        title: "Accommodation Reports",
        href: "/bmo-user-admin-dashboard/AccommodationReports",
        icon: "bi bi-house-door",
      }
    ]
  },
  {
    title: "BMO Settings",
    href: "/bmo-user-admin-dashboard/BMOSettings",
    icon: "bi bi-gear",
  },
];

const BMOUserAdminSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState({});

  const toggleDropdown = (index) => {
    setDropdownOpen(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };
  
  const closeSidebar = () => {
    document.getElementById("sidebarArea").classList.toggle("showSidebar");
  };

  return (
    <div className="p-3">
      {/* Mobile close button - only visible on small screens */}
      <div className="d-flex justify-content-end d-lg-none mb-2">
        <Button
          color="link"
          size="sm"
          className="text-dark p-1"
          onClick={closeSidebar}
          style={{ border: 'none' }}
        >
          <i className="bi bi-x-lg" style={{ fontSize: '1.2rem', color: '#000' }}></i>
        </Button>
      </div>
      
      <div className="d-flex align-items-center">
        <div className="text-center w-100 mb-3">
          <h6 className="text-muted mb-0">BMO User Admin</h6>
        </div>
      </div>
      <div className="pt-4 mt-2">
        <Nav vertical className="sidebarNav">
          {navigation.map((navi, index) => (
            <NavItem key={index} className="sidenav-bg">
              {navi.hasDropdown ? (
                <>
                  <div
                    className="nav-link py-3 d-flex justify-content-between align-items-center dropdown-parent"
                    style={{ 
                      color: "#000", 
                      cursor: "pointer",
                      backgroundColor: dropdownOpen[index] ? "rgb(230 238 248)" : "transparent",
                      fontSize: navi.title.length > 12 ? "12px" : "inherit",
                      fontWeight: navi.title.length > 12 ? "600" : "normal"
                    }}
                    onClick={() => toggleDropdown(index)}
                  >
                    <div>
                      <i className={navi.icon} style={{ color: "#000" }}></i>
                      <span className="ms-3 d-inline-block">{navi.title}</span>
                    </div>
                    <i className={`bi ${dropdownOpen[index] ? 'bi-chevron-up' : 'bi-chevron-down'}`} 
                       style={{ color: "#000" }}></i>
                  </div>
                  <Collapse isOpen={dropdownOpen[index]}>
                    <div style={{ backgroundColor: "rgb(230 238 248)", borderRadius: "4px", margin: "0 8px" }}>
                      {navi.children && navi.children.map((child, childIndex) => (
                        <Link
                          key={childIndex}
                          to={child.href}
                          className="nav-link py-2 ps-3"
                          style={{ 
                            color: "#000", 
                            fontSize: child.title.length > 12 ? "12px" : "0.9rem",
                            fontWeight: child.title.length > 12 ? "600" : "normal",
                            backgroundColor: "transparent"
                          }}
                          onClick={() => navigate(child.href)}
                        >
                          <i className={child.icon} style={{ color: "#000" }}></i>
                          <span className="ms-2 d-inline-block">{child.title}</span>
                        </Link>
                      ))}
                    </div>
                  </Collapse>
                </>
              ) : (
                <Link
                  to={navi.href}
                  className={
                    location.pathname === navi.href
                      ? "nav-link py-3"
                      : "nav-link py-3"
                  }
                  style={{ 
                    color: "#000",
                    fontSize: navi.title.length > 12 ? "12px" : "inherit",
                    fontWeight: navi.title.length > 12 ? "600" : "normal"
                  }}
                >
                  <i className={navi.icon} style={{ color: "#000" }}></i>
                  <span className="ms-3 d-inline-block">{navi.title}</span>
                </Link>
              )}
            </NavItem>
          ))}
        </Nav>
      </div>
    </div>
  );
};

export default BMOUserAdminSidebar;
